/** Ereignistypen des Kontexts Lage (ereignisspeicher.md §6.4, Domänenmodell §6; ASCII-Umschrift, ADR-0006). */
export const LAGE_EREIGNIS = {
  WildsichtungGemeldet: "WildsichtungGemeldet",
  WildsichtungStorniert: "WildsichtungStorniert",
  SchuetzeAngestellt: "SchuetzeAngestellt",
  StandErreicht: "StandErreicht",
  SchuetzeAbgeholt: "SchuetzeAbgeholt",
  TreibergruppeAmStart: "TreibergruppeAmStart",
  TreibergruppeAmSammelpunkt: "TreibergruppeAmSammelpunkt",
  HundVermisstGemeldet: "HundVermisstGemeldet",
  HundGesichtet: "HundGesichtet",
  HundZurueckGemeldet: "HundZurueckGemeldet",
  NotrufAbgesetzt: "NotrufAbgesetzt",
  NotrufErgaenzt: "NotrufErgaenzt",
  NotrufQuittiert: "NotrufQuittiert",
  NotrufErledigt: "NotrufErledigt",
} as const;

/** Aggregattypen (ereignisspeicher.md §3). */
export const LAGE_AGGREGAT = {
  Wildsichtung: "Wildsichtung", Anstellung: "Anstellung", Treibergruppenmeldung: "Treibergruppenmeldung",
  Vermisstmeldung: "Vermisstmeldung", Notruf: "Notruf",
} as const;

export const ANSTELLUNG_EREIGNISSE: readonly string[] = [LAGE_EREIGNIS.SchuetzeAngestellt, LAGE_EREIGNIS.StandErreicht, LAGE_EREIGNIS.SchuetzeAbgeholt];
export const TREIBERGRUPPEN_EREIGNISSE: readonly string[] = [LAGE_EREIGNIS.TreibergruppeAmStart, LAGE_EREIGNIS.TreibergruppeAmSammelpunkt];
export const VERMISST_EREIGNISSE: readonly string[] = [LAGE_EREIGNIS.HundVermisstGemeldet, LAGE_EREIGNIS.HundGesichtet, LAGE_EREIGNIS.HundZurueckGemeldet];
export const NOTRUF_EREIGNISSE: readonly string[] = [
  LAGE_EREIGNIS.NotrufAbgesetzt, LAGE_EREIGNIS.NotrufErgaenzt, LAGE_EREIGNIS.NotrufQuittiert, LAGE_EREIGNIS.NotrufErledigt,
];
export const WILDSICHTUNG_EREIGNISSE: readonly string[] = [LAGE_EREIGNIS.WildsichtungGemeldet, LAGE_EREIGNIS.WildsichtungStorniert];
